---
fr:
  activerecord:
    models:
      comment:
        one: Commentaire
        other: Commentaires
  comments:
    add_comment: Ajouter un commentaire
    notify_replies: Informez-moi des réponses
